import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  ParcelAppEntityParcelWrite
} from '../../../../../../../openapi';
import { CustomValidator, fromToDate } from '../../../../../../../common/forms/custom.validators';

export type ProjectTypeItem = 'Stałej' | 'Czasowej' | string;

@Injectable()
export class TrafficOrganizationProjectForm extends AppForm {

  constructor() {
    super({
      projectType: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      trafficOrganizationDescription: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(5000)]
      }),
      street: new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.maxLength(255)] }),
      startDate: new FormControl(null, [Validators.required, CustomValidator.minDate(new Date())]),
      trafficOrganizationApplicant: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      investor: new FormControl(null, Validators.maxLength(255)),
      parcels: new FormControl<ParcelAppEntityParcelWrite[]>(
        [], {
          nonNullable: true,
          validators: [Validators.required, Validators.minLength(1)]
        }
      )
    }, {
      validators: [fromToDate('startDate', 'endDate')]
    });
  }

  public projectTypeChange(v: ProjectTypeItem): void {
    if (v === 'Czasowej') {
      this.addControl('endDate', new FormControl(null, Validators.required));

      this.addControl('organizerOrContractorType', new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }));
      this.addControl('organizerOrContractorName', new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }));
    } else {
      this.removeControl('endDate');

      this.removeControl('organizerOrContractorType');
      this.removeControl('organizerOrContractorName');
    }
  }

  public get endDate(): FormControl | null {
    return this.get('endDate') as FormControl | null;
  }

  public get startDate(): FormControl | null {
    return this.get('startDate') as FormControl | null;
  }

  public get organizerOrContractorType(): FormControl | null {
    return this.get('organizerOrContractorType') as FormControl | null;
  }

  public get organizerOrContractorName(): FormControl | null {
    return this.get('organizerOrContractorName') as FormControl | null;
  }

  public get parcels(): FormControl {
    return this.get('parcels') as FormControl;
  }

  public get parcelsValues(): ParcelAppEntityParcelWrite[] {
    return this.parcels.value;
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    let value = this.value;
    delete value.parcels;
    return value;
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    super.patchFormValues(value);
    this.projectTypeChange(value?.projectType || '');

    this.endDate?.setValue(value?.endDate);
    this.organizerOrContractorType?.setValue(value?.organizerOrContractorType);
    this.organizerOrContractorName?.setValue(value?.organizerOrContractorName);
  }
}
